import "./ProjectsGrid.css";

// import riverstoneResidence from "../../assets/riverstone-residence.jpg";
// import shindeHouse from "../../assets/graphite-kitchen.jpg";
// import pranavKhot from "../../assets/atelier-apartment.jpg";

import riverstoneResidence from "../../assets/riverstone-residence.jpg";
import displayImage from "../../assets/pranav-khot-house/finel-fan.png";
import shindeHouse from "../../assets/shinde-house/shinde house c bed.png";
import pranavKhot from "../../assets/pranav-khot-house/orchid-tv11.png";
import aurangabadHouse from "../../assets/aurangabad-house/ChatGPT Image Sep 4, 2026, 05_50_02 PM.png";
import commercialProject from "../../assets/comarcial-project/Enscape_2025-01-20-13-50-11.png";


const PROJECTS = [
 
  {
    slug: "shinde-house",
    image: shindeHouse,
    alt: "Shinde House, 3BHK Bunglow in Nigadi Pradhikaran, Pune",
    tag: "Actual site picture",
    title: "Shinde House ",
    status: "Completed",
    details: [
      { label: "Location", value: "Nigadi Pradhikaran, Pune" },
      { label: "Type", value: "3BHK Bunglow" },
      { label: "Area", value: "2200 sq ft" },
      {
        label: "Scope",
        value: "Complete renovation, including toilet, electrical work, flooring, and furniture.",
      },
    ],
  },

  {
    slug: "stellar-homes",
    image: displayImage,
    alt: "The Stellar Homes, 2BHK Apartment in Wakad, Pune",
    tag: "Actual site picture",
    title: "The Stellar Homes",
    status: "Completed",
    offset: true,
    details: [
      { label: "Location", value: "Wakad, Pune" },
      { label: "Type", value: "2BHK Apartment" },
      { label: "Area", value: "750 sq ft" },
      {
        label: "Scope",
        value: "Full interior · kitchen, wardrobes, living, lighting",
      },
    ],
  },

  {
    slug: "bunglow-interior",
    image: aurangabadHouse,
    alt: "Bunglow Interior, 4BHK Bunglow in Vaijapur",
    tag: "Actual site picture",
    title: "Bunglow Interior",
    status: "Completed",
    details: [
      { label: "Location", value: "Vaijapur" },
      { label: "Type", value: "4BHK Bunglow " },
      { label: "Area", value: "2500 sq ft" },
      {
        label: "Scope",
        value: "Full interior · kitchen, wardrobes, living, lighting",
      },
    ],
  },

 {
    slug: "riverstone-residence",
    image: riverstoneResidence,
    alt: "Riverstone Residence, 4BHK Apartment in Baner, Pune",
    tag: "Upcoming",
    title: "Riverstone Residence",
    status: "In the Making",
    offset: true,
    details: [
      { label: "Location", value: "Baner, Pune" },
      { label: "Type", value: "4BHK Apartment" },
      { label: "Area", value: "1,850 sq ft" },
      {
        label: "Scope",
        value: "Full interior · kitchen, wardrobes, living, lighting",
      },
    ],
  },

  // {
  //   slug: "up-coming-project",
  //   image: commercialProject,
  //   alt: "Commercial Project, commercial interior in Wakad",
  //   tag: "Upcoming",
  //   title: "Commercial Project",
  //   status: "Upcoming",
  //   details: [
  //     { label: "Location", value: "Wakad" },
  //     { label: "Type", value: "Commercial Interior" },
  //     { label: "Area", value: "450 sq ft" },
  //     {
  //       label: "Scope",
  //       value: "Commercial interior planning, reception, work area, cabin, and storage.",
  //     },
  //   ],
  // },

];

function ProjectCard({ project }) {
  const projectUrl = `/${project.slug}`;

  return (
    <article className={`pg-article${project.offset ? " pg-article--offset" : ""}`}>
      <a
        href={projectUrl}
        className="pg-reveal-img"
        aria-label={`View details for ${project.title}`}
      >
        <img
          src={project.image}
          alt={project.alt}
          width={1200}
          height={1504}
          loading="lazy"
          className="pg-image"
        />
        <span className="pg-badge">{project.tag}</span>
      </a>

      <a href={projectUrl} className="pg-header-row" aria-label={`View details for ${project.title}`}>
        <span className="pg-status">{project.status}</span>
        <div className="pg-title-row">
          <h2 className="pg-title">{project.title}</h2>
          <span className="pg-arrow" aria-hidden="true">
            ↗
          </span>
        </div>
      </a>

      <dl className="pg-details">
        {project.details.map((d) => (
          <div className="pg-detail" key={d.label}>
            <dt className="pg-detail-label">{d.label}</dt>
            <dd className="pg-detail-value">{d.value}</dd>
          </div>
        ))}
      </dl>
    </article>
  );
}

export default function ProjectsGrid() {
  return (
    <section className="pg-section" id="projects">
      <div className="pg-section-header">
        <h1 className="pg-section-title">Selected work</h1>
        <a href="/project" className="pg-all-link">
          All Projects <span aria-hidden="true">→</span>
        </a>
      </div>

      <div className="pg-grid">
        {PROJECTS.map((project) => (
          <ProjectCard project={project} key={project.title} />
        ))}
      </div>

      {/* <p className="pg-note">
        Visuals marked Design Concept, 3D Visualization or Proposed Interior
        are representations of intent, not photographs of completed work.
      </p> */}

      <div className="pg-cta-wrap">
        <a href="/project" className="pg-cta-btn">
          View All Projects
        </a>
      </div>
    </section>
  );
}
